<campus-elevated-card [ngClass]="highlight ? ['border', 'border-primary'] : []" [relative]="false">
  <campus-card-hero class="frame-contain"><img [src]="imageUrl" /></campus-card-hero>
  @if (learningAreaName) {
    <campus-card-overline-head class="center-content">{{
      learningAreaName
    }}</campus-card-overline-head>
  }
  @if (title) {
    <campus-card-headline>{{ title }}</campus-card-headline>
  }
  <campus-card-action-area class="[ cluster ]">
    @if (rowDisplayType === 'multiple') {
      <div class="justify-center">
        <campus-select
          [ngModel]="selected"
          type="button"
          label="Kies jaar"
          data-cy="product-card-menu-trigger"
          multiple
          checkbox
          badge
          >
          @for (row of rows; track trackByGuid($index, row)) {
            <campus-select-option
              [value]="row"
              [label]="row.label"
              (click)="selectionChanged(row)"
              data-cy="product-card-menu-row"
            ></campus-select-option>
          }
        </campus-select>
      </div>
    }
    @if (rowDisplayType === 'menu') {
      @if (rows?.length <= 1) {
        <div class="justify-center">
          @for (row of rows; track trackByGuid($index, row)) {
            <button
              filled-button
              (click)="selectionChanged(row)"
              data-cy="product-card-row"
              >
              {{ row.label }}
            </button>
          }
        </div>
      }
      @if (rows?.length > 1) {
        <div class="justify-center">
          <div>
            <button filled-button #popoverTrigger trailingIcon="arrow-drop-down" data-cy="product-card-menu-trigger"
              >Kies jaar</button
              >
              <campus-menu [anchor]="popoverTrigger" positioning="fixed">
                @for (row of rows; track trackByGuid($index, row)) {
                  <campus-menu-item
                    [label]="row.label"
                    (click)="selectionChanged(row)"
                    data-cy="product-card-row"
                  ></campus-menu-item>
                }
              </campus-menu>
            </div>
          </div>
        }
      }
      @if (rowDisplayType === 'actions') {
        <div class="[ stack ]">
          @for (row of rows; track trackByGuid($index, row)) {
            <div
              class="[ w-full flex justify-between center-items ]"
              data-cy="product-card-row"
              >
              @if (row.label) {
                <span class="title-small" data-cy="product-card-title">
                  {{ row.label }}
                </span>
              }
              @if (row.actions?.length) {
                <div>
                  <div class="[ flex ]">
                    @for (action of row.actions; track action) {
                      <button
                        inline-icon-button
                        (click)="action.handler(row.guid, data?.id)"
                        [icon]="action.icon.icon"
                        data-cy="product-card-action"
                        [plainTooltip]="action.tooltip"
                      ></button>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </campus-card-action-area>
  </campus-elevated-card>
